import React from "react";
import PageHeader from "@/components/common/PageHeader";
import { useOutletContext } from "react-router-dom";
import { Sparkles, MessageSquareText, FileText, PieChart, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AIPage() {
  const { openAI } = useOutletContext() || {};

  return (
    <div className="p-6 lg:p-8 space-y-6" data-testid="ai-page">
      <PageHeader
        eyebrow="AI Native"
        title="AI Accounting Assistant"
        description="Powered by GPT-5.2 · India-context aware · Explainable — never posts silently."
        actions={<Button onClick={() => openAI && openAI()} className="rounded-sm bg-accent hover:bg-accent/90 text-white gap-1.5" data-testid="open-ai-btn"><Sparkles className="w-4 h-4" /> Open Assistant</Button>}
      />
      <div className="grid md:grid-cols-4 gap-4">
        {[
          { icon: MessageSquareText, t: "Natural-language JVs", d: "Describe a transaction, get a balanced draft entry with account codes." },
          { icon: FileText, t: "Document extraction", d: "Upload a bill, get the payable entry pre-filled with GST split." },
          { icon: PieChart, t: "Explain the numbers", d: "\"Why did my profit fall in Jan?\" — get plain-English answers." },
          { icon: ShieldAlert, t: "Anomaly detection", d: "Duplicate vendors, GL vs sub-ledger mismatches, missing tax mappings." },
        ].map((f) => {
          const Icon = f.icon;
          return (
            <div key={f.t} className="card-sharp p-5">
              <Icon className="w-5 h-5 text-accent mb-3" />
              <div className="font-heading font-semibold">{f.t}</div>
              <div className="text-xs text-muted-foreground mt-1.5 leading-relaxed">{f.d}</div>
            </div>
          );
        })}
      </div>

      <div className="card-sharp p-8 relative overflow-hidden bg-primary text-primary-foreground">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="relative z-10 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-accent mb-3">// Now open on the right</div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight">Talk to your books.</h2>
            <p className="mt-4 text-primary-foreground/80 max-w-md">The AI panel is now open. Type a question or describe a transaction — I'll draft a balanced JV with GST/TDS treatment.</p>
          </div>
          <div className="space-y-2">
            {[
              "Book office rent ₹45,000 April from ICICI with GST and Admin",
              "Show me all vendor bills over ₹1,00,000 last month",
              "What's my current GST liability?",
              "Explain Schedule II depreciation for computers",
            ].map((q) => (
              <div key={q} className="border border-primary-foreground/20 rounded-sm px-3 py-2 text-xs font-mono text-primary-foreground/70">→ {q}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
